export default __webpack_public_path__ + "static/coding-partner-banner-b4dfe3dc1ed40aa95022e21b77f084b8.jpg";